import { render } from "./Paths.vue?vue&type=template&id=67713016"
import script from "./Paths.vue?vue&type=script&lang=js"
export * from "./Paths.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__